import HeaderNav from "./HeaderNav";

function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="bentolio-page">
      <div className="bentolio-shell">
        <HeaderNav />
        {children}
      </div>
    </div>
  );
}

export default Layout;
